module.exports = {
  text: `Стидеры напоминают пауков так же, как ворги напоминают волков. Существа могут казаться похожими, но стидеры — это нечто больше, чем просто паразиты.`,
  author: `Архимаг Морденкайнен`,
}
